import { memo, ButtonHTMLAttributes } from 'react'

import s from './Buttons.module.scss'
import { useSwiper } from 'swiper/react'

type IButtonsProps = {
    onClick?: any
} & ButtonHTMLAttributes<HTMLButtonElement>

export const PreviousButton = memo(({ onClick, ...props }: IButtonsProps) => {
    const swiper = useSwiper()
    return (
        <button
            className={`${s.button} ${props.className ? props.className : ''}`}
            onClick={onClick ? ()=>{onClick(); swiper.slidePrev()} : ()=>swiper.slidePrev()}
            {...props}
        >
            <svg
                width='21'
                height='20'
                viewBox='0 0 21 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M0.792893 10.7071C0.402369 10.3166 0.402369 9.68342 0.792893 9.29289L7.15685 2.92893C7.54738 2.53841 8.18054 2.53841 8.57107 2.92893C8.96159 3.31945 8.96159 3.95262 8.57107 4.34314L2.91421 10L8.57107 15.6569C8.96159 16.0474 8.96159 16.6805 8.57107 17.0711C8.18055 17.4616 7.54738 17.4616 7.15686 17.0711L0.792893 10.7071ZM19.5 9C20.0523 9 20.5 9.44771 20.5 10C20.5 10.5523 20.0523 11 19.5 11L19.5 9ZM1.5 9L19.5 9L19.5 11L1.5 11L1.5 9Z'
                    fill='#FBECEC'
                />
            </svg>
        </button>
    )
})

export const NextButton = memo(({ onClick }: IButtonsProps) => {
    const swiper = useSwiper()
    return (
        <button
            className={s.button}
            onClick={onClick ? ()=>{onClick(); swiper.slideNext()} : ()=>swiper.slideNext()}
        >
            <svg
                width='21'
                height='20'
                viewBox='0 0 21 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M20.2071 10.7071C20.5976 10.3166 20.5976 9.68342 20.2071 9.29289L13.8431 2.92893C13.4526 2.53841 12.8195 2.53841 12.4289 2.92893C12.0384 3.31945 12.0384 3.95262 12.4289 4.34314L18.0858 10L12.4289 15.6569C12.0384 16.0474 12.0384 16.6805 12.4289 17.0711C12.8195 17.4616 13.4526 17.4616 13.8431 17.0711L20.2071 10.7071ZM1.5 9C0.947716 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11L1.5 9ZM19.5 9L1.5 9L1.5 11L19.5 11L19.5 9Z'
                    fill='#FBECEC'
                />
            </svg>
        </button>
    )
})
